// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2wWjx","title":"AfterFrontImage_title__2mdqQ"};